import { Component,OnInit,ViewChild,ElementRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SMCService } from 'src/app/services/smc.service';
import * as dayjs from 'dayjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { environmentConfig } from '../../../../environment';
import { HttpHeaders, HttpClient, HttpEvent } from '@angular/common/http';
import { Modal } from 'bootstrap';
import { MultiSelectComponent } from 'ng-multiselect-dropdown'

@Component({
  selector: 'app-smc',
  templateUrl: './smc.component.html',
  styleUrls: ['./smc.component.css']
})
export class SecureMessagingComponent implements OnInit {
  @ViewChild('dropdownUsers', { static: false }) dropdownUsers!: MultiSelectComponent;

  apiUrl = environmentConfig.apiBaseUrl;


  userID: any = sessionStorage.getItem('wOSAuthUser');
  userPrefs: any = sessionStorage.getItem('wOSUserPrefs');
  user: any = sessionStorage.getItem('wOSUser');
  userRole: any = sessionStorage.getItem('wOSUserRole');
  userName = JSON.parse(this.userPrefs).old_name;
  token = JSON.parse(this.user).stsTokenManager.accessToken;

  ddSettingsSender: IDropdownSettings = {};
  ddSettingsUser: IDropdownSettings = {};
  errorMsg = "";
  errorMsgColor = "red";



  allMessages: any[] = [];
  composerSubject = "";
  composerMessage = "";
  composerSender: any[] = [{ fullname: this.userName, uid: parseInt(this.userID) }];
  composerRecipients: any[] = [];

  countDraft = 0;
  countNew = 0;
  countSent = 0;
  countTrash = 0;

  currentFolder = "Inbox";
  currentIcon = "inbox";
  currentMessageID = -1;

  displayMessages: any[] = [];
  driveSMC = "1uDYRUJynQtF2egD5QpOY-26VbbLWGAqZ";
  driveTech = "0ALb85gqM1AESUk9PVA";

  fileContainer: any;

  folderCurrent: any[] = [];
  folderInbox: any[] = [];
  folderSent: any[] = [];
  folderDrafts: any[] = [];
  folderTrash: any[] = [];

  intervalRefresh: any = {};

  listUsers: any[] = [];

  msgID = 0;
  msgSubject = "";
  msgBody: SafeHtml = "";
  msgSender = "";
  msgSenderName = "";
  msgSenderEmail = "";
  msgSenderInitials = "";
  msgRecip = "";
  msgRecipName = "";
  msgRecipEmail = "";
  msgRecipInitials = "";

  tinyMCEKey = "0g4d8txs6vxxoeqkecpqdd4rnyp24ptvtqdtusah0hqhsplb";

  uploadFiles: File[] | null = null;
  uploadList: any[] = [];
  uploadDetail = "";

  public config: any = {
    height: 240,
    menubar: false,
    plugins: [
      "advlist", "anchor", "autolink", "charmap", "code", "fullscreen",
      "help", "image", "insertdatetime", "link", "lists"
    ],
    toolbar: 'bold italic underline | link | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat'
  };

  constructor(
    private router: Router,
    private authService: AuthService,
    private smcService: SMCService,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.ddSettingsUser = {
      singleSelection: false,
      idField: 'uid',
      textField: 'fullname',
      enableCheckAll: false,
      allowSearchFilter: false,
      closeDropDownOnSelection: false
    };

    this.ddSettingsSender = {
      singleSelection: true,
      idField: 'uid',
      textField: 'fullname',
      enableCheckAll: false,
      allowSearchFilter: true
    };

    this.getInboxData();
    this.toggleFolder('inbox')
    
  }

  getInboxData(): void {
    this.smcService.getInbox(this.userID, this.token).then(r => {
      console.log("GetInbox",r)
      this.allMessages = r.messages || [];
      console.log("All Messages >> ", this.allMessages)
      this.listUsers = r.users;

      this.folderInbox = this.allMessages.filter(o => o.isdraft == 0 && o.isdeleted == 0 && o.issent == 1 && o.msg_recipient == this.userID);
      console.log("Inbox >> ", this.folderInbox.length, this.folderInbox)

      this.folderSent = this.allMessages.filter(o => o.msg_sender == this.userID && o.issent == 1);
      this.folderDrafts = this.allMessages.filter(o => o.isdraft > 0 && o.msg_sender == this.userID);
      this.folderTrash = this.allMessages.filter(o => o.isdeleted > 0);

      this.countNew = this.folderInbox.filter(o => o.isopened == 0).length;
      this.countSent = this.folderSent.length;
      this.countDraft = this.folderDrafts.length;
      //this.trashCount = this.folderTrash.length;
      this.folderCurrent = this.folderInbox;

    });
  }

  toggleFolder(folder: string): void {
    this.msgID = 0;
    this.currentFolder = folder.charAt(0).toUpperCase() + folder.slice(1);
    this.currentIcon = (folder == 'inbox') ? 'inbox' : (folder == 'sent') ? 'play' : (folder == 'drafts') ? 'pen-to-square' : 'trash';
    this.folderCurrent = (folder == 'inbox') ? this.folderInbox : (folder == 'sent') ? this.folderSent : (folder == 'drafts') ? this.folderDrafts : this.folderTrash;
    $('#smc_folders > li > a').removeClass('nav-link-active')
    $('#lnk_' + folder).addClass('nav-link-active')
  }

  loadComposer(): void {
    $('.tox-statusbar').hide();
    setTimeout(() => {
      $('#composerSubject').trigger('focus');
    },500)
  }

  // when file(s) are attached
  // retain for upload later and display the selected names

  async populateList(event: any): Promise<void> {
    this.fileContainer = (event.target as HTMLInputElement)?.files;
    const fileCounter = (event.target as HTMLInputElement)?.files?.length;
    
    this.uploadList = [];
    if (fileCounter! > 0) 
      for (let f = 0; f < fileCounter!; f++) {
        const selectedFile = (event.target as HTMLInputElement)?.files?.[f] ?? null;
        this.uploadList.push(selectedFile?.name);
      }
    else 
      this.uploadList = [];
    

    // format the file list for display
    this.uploadDetail = this.uploadList.join('<br>');
  }

  async saveMessage(mode:string | null = "save"): Promise<string> {
    const recips = this.composerRecipients;

    // if it's a full send - validate required fields
    if (mode == 'send') { 
      if (recips.length == 0) {
        this.errorMsg = "Please select at least one recipient to continue.";
        this.clearErrorState();
        return "";
      }

      if (this.composerSubject.trim() == '') {
        this.errorMsg = "Please enter a subject to continue.";
        this.clearErrorState();
        return '';
      }

      if (this.composerMessage.trim() == '') {
        this.errorMsg = "Please enter a message to continue.";
        this.clearErrorState();
        return '';
      }
    }

    // create the json object that gets passed to the save routine
    const json = {
      "sub": this.composerSubject,
      "body": this.composerMessage,
      "sender": this.composerSender,
      "recipients": recips,
      "isdraft": (mode == "send") ? 0 : 1,
      "issent": (mode == "send") ? 1 : 0,
    }

    this.smcService.saveMessage(this.userID, json, this.token).then(r => {
      this.currentMessageID = r;
      console.log("Current Message ID >> ", this.currentMessageID, this.fileContainer.length)

      if (this.fileContainer.length > 0) {
        for (let f = 0; f < this.fileContainer.length;f++) {
          const test = this.uploadOneFile(this.fileContainer[f], this.token, this.userID).then(r => {
            console.log("File Uploaded >> ", r)
          })
        }
      } else {
        console.log("No attachments")
      }

      this.errorMsg = "Message saved as a Draft - " + this.currentMessageID;
      this.errorMsgColor = "green";
      this.clearErrorState();

      $('#composeModal').modal('hide');
    })
    return this.currentMessageID.toString();
  }

  async sendMessage(): Promise<string> {
    return 'ok';
  }

  onSenderSelect(item: any) {
    console.log(item.uid, this.composerSender)
  }

  onRecipientSelect(item: any) {
    console.log(item);
      try {
        this.dropdownUsers.closeDropdown();
      } catch (ex) {
        return;
      }
    }


  clearErrorState(length = 5000): void {
    setTimeout(() => {
      this.errorMsg = "";
      this.errorMsgColor = "red";
    }, length)
  }

  getSafeHTML(content: string): SafeHtml {
    const ret = this.sanitizer.bypassSecurityTrustHtml(content);
    return ret;
  }

  formatDate(dtstamp: string): string {
    return dayjs(dtstamp).format("MM/DD/YYYY hh:mmA")
  }

  loadMessage(mid: number): void {
    $('.list-group-item').removeClass('active-email');
    $('#msg_' + mid).addClass('active-email');
    const msg = this.allMessages.find(o => o.id === mid);

    console.log("Selected Message >> ", msg)

    this.msgSubject = msg.msg_subject;
    this.msgBody = this.getSafeHTML(msg.decrypted_msg);
    this.msgSenderName = msg.sender_name;
    this.msgSenderInitials = msg.sender_initials;
    this.msgSenderEmail = msg.sender_email;
    this.msgRecipName = msg.recipient_name;
    this.msgRecipEmail = msg.recipient_email;
    this.msgID = msg.id;
  }

  async uploadOneFile(
    file: File,
    token: string,
    uploadedBy?: string
  ): Promise<string> {
    const url = `${this.apiUrl}/api/smc/attach`;
    const form = new FormData();
    form.append('file', file, file.name);
    form.append('msgid', this.currentMessageID.toString())
    if (uploadedBy) form.append('uploadedBy', uploadedBy);

    await this.http.post(url, form, {
      headers: this.authHeaders(token)
    }).subscribe({
      next: (data) => console.log(data), // Success callback
      error: (error) => { console.log(error) }, // Error callback
      complete: () => console.log('Request complete') // Completion callback
    })
    return "ok"
  }

  private authHeaders(token: string) {
    return new HttpHeaders(token ? { Authorization: `Bearer ${token}` } : {});
  }
}
